module.exports = __webpack_public_path__ + "static/media/oppo-indonesia-5.b352c7c1.jpg";